<div class="container-full has-background-white-bis mb-8">
  <div class="container">
    <div class="columns">
      <div class="column">
        <app-breadcrumb></app-breadcrumb>
      </div>
    </div>
  </div>
</div>
<div class="container mb-9">
  <div class="columns">
    <div class="column is-12">
      <div class="content">
        <h1 class="title is-2 has-text-weight-bold has-line">About</h1>

        <h2 class="title is-3 has-text-weight-bold">Why this portal?</h2>
        <p>
          The OECD INNOTAX portal is the reference platform for policy analysis
          and comparison and up-to-date evidence on the use, generosity, cost
          and impact of tax incentives for R&D and innovation supporting government officials,
          policy analysts and scholars. Tax incentives have become a major tool in the business
          innovation support policy mix of countries in the OECD area and beyond. Since 2007,
          the OECD has continuously worked to extend the international evidence on tax
          incentives for R&D and innovation and has developed methodologies
          (<a
            href="https://www.oecd.org/en/publications/frascati-manual-2015_9789264239012-en.html"
            target="_blank"
            >OECD, 2015</a
          >) and
          <a
            href="https://data-explorer.oecd.org/vis?df[ds]=dsDisseminateFinalDMZ&df[id]=DSD_RDTAX%40DF_RDTAX&df[ag]=OECD.STI.STP&df[vs]=1.0&pd=2015,&dq=.A..PT_B1GQ..&to[TIME_PERIOD]=false"
            target="_blank"
            >data infrastructures</a
          >
          that are widely used by experts in the policy, statistical, tax
          advisory and academic arena.
        </p>
        <p>
          This interactive OECD tool, developed with financial support from
          the EU Horizon Programme, builds upon and extends the existing
          <a href="https://www.oecd.org/en/topics/sub-issues/rd-tax-incentives.html" target="_blank"
            >OECD research infrastructure on R&D tax incentives</a
          >, enabling users to visualise, explore and compare the design and
          administration of expenditure-based R&D tax incentives across OECD
          countries and partner economies, and access the latest OECD indicators
          and analysis in this area. Since September 2026, the portal has been extended to also
          cover income-based tax incentives for R&D and innovation, enabling users
          to examine and compare a broader range of tax policy instruments used
          to encourage R&D and innovation. The OECD INNOTAX portal is hosted by the OECD-EC
          <a href="https://stip.oecd.org/stip/" target="_blank"
            >STIP Compass policy database</a
          >, a leading resource on national policies for science, technology and innovation.
        </p>
        <h2 class="title is-3 has-text-weight-bold">
          Where do the data in the INNOTAX portal come from?
        </h2>
        <p>
          INNOTAX provides the most up-to-date information on the design,
          implementation and role of R&D tax incentives in the innovation
          policy mix of OECD countries and partner economies, drawing on the
          contributions of members of the OECD R&D tax incentives expert network
          to the OECD R&D tax incentives data collection and OECD IPTAX survey
          on income-based tax incentives for R&D and innovation. The OECD expert
          network on R&D tax incentives comprises government officials from STI ministries,
          tax offices and national statistical organisations (NSOs) in all OECD
          member countries, EU member states and several other major economies,
          with responsibility for responding to these OECD surveys. This informal
          network draws on contacts from the OECD Committee for Scientific and
          Technological Policy (CSTP), its Working Party of National Experts on
          Science and Technology Indicators (NESTI) and the Committee for Fiscal
          Affairs’ Working Party No 2 on Tax Policy Analysis and Tax Statistics
          (WP2) and OECD Forum on Harmful Tax Practices (FHTP).
        </p>

        <h2 class="title is-3 has-text-weight-bold">
          What are the main features of the INNOTAX portal?
        </h2>
        <p>
          The OECD INNOTAX portal incorporates interactive dashboards for the
          visualisation of key design features and the similarity of national tax
          incentive schemes, coupled with interactive charts that provide the latest
          evidence on the use, generosity and cost of expenditure-based and
          income-based tax incentives for R&D and innovation in the OECD area
          and beyond. In addition to these interactive dashboards and charts,
          INNOTAX provides a sophisticated interactive tool with smart filtering
          that facilitates policy discovery, analysis and comparison, including
          the retrieval of expenditure-based tax incentive schemes with similar
          design features. The visual interfaces allow users to seamlessly query
          the INNOTAX database to identify and compare national tax incentive
          schemes on a wide range of different dimensions that relate to the
          design and/or implementation of tax incentives.
        </p>

        <h2 class="title is-3 has-text-weight-bold">
          Your opinion matters to us
        </h2>
        <p>
          <a
            href="mailto:RDTaxStatsContact@oecd.org?subject=Feedback%20and%20suggestions%20on%20INNOTAX%20portal"
            >Send us</a
          >
          your feedback and suggestions on how to improve our tool.
        </p>
      </div>
    </div>
  </div>
</div>
